module.exports = __webpack_public_path__ + "img/product_2.d45ff0b.svg";